module.exports = "/_next/static/images/DeliverExperiences-548d08cec999366fdfaec29e8e14ab82.png";